module.exports = __webpack_public_path__ + "img/icon_capability04.fc4c8ecd.png";